module.exports = __webpack_public_path__ + "img/marconi_logo.76f00e99.webp";